import { regexEmail } from 'mailup-react-helpers'
import { Button, InputText } from 'mailup-web-components'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import './InputEmail.scss'

export const InputEmail = ({ lastEmails, searchRecipientsCallback }) => {
  const intl = useIntl()
  const [email, setEmail] = useState('')
  const [error, setError] = useState(null)
  const [lastEmailsSelected, setLastEmailsSelected] = useState(lastEmails)
  const [lastEmailsList, setLastEmailsList] = useState(lastEmails)

  const handleChange = (e) => {
    setEmail(e.target.value)
  }

  const selectEmail = (email) => {
    const listEmail = [
      {
        value: email.value,
        selected: true
      }
    ]

    // eslint-disable-next-line array-callback-return
    lastEmails.map((e) => {
      if (e.value !== email.value) {
        listEmail.push({
          value: e.value,
          selected: false
        })
      }
    })

    setLastEmailsSelected(listEmail)
    setEmail(email.value)
  }

  useEffect(() => {
    if (lastEmails && lastEmails.length > 0) {
      setLastEmailsSelected(lastEmails)

      const emailsList = []
      lastEmails.forEach((email) => emailsList.push(email.value))
      setLastEmailsList(emailsList)

      const emails = lastEmails.filter((email) => email.selected)
      if (emails && emails.length > 0) {
        selectEmail(emails[0])
        intSearchRecipient(emails[0].value)
      }
    }
  }, [lastEmails])

  const handleApply = (selectedEmail) => {
    if (!regexEmail.test(selectedEmail)) {
      setError(
        intl.formatMessage({
          id: 'Load.Common.WrongFormatWarning'
        })
      )
    } else {
      searchRecipient(selectedEmail)
    }
  }

  const searchRecipient = (selectedEmail) => {
    const emails = [selectedEmail]
    lastEmailsList.forEach((email) => {
      if (selectedEmail !== email && emails.length < 3) {
        emails.push(email)
      }
    })

    setLastEmailsList(emails)

    searchRecipientsCallback(
      { email: selectedEmail },
      {
        lastEmails: [...emails],
        lastTypeSelected: 'email'
      },
      []
    ).then((res) => {
      if (res.Items.length === 0) {
        setError(
          intl.formatMessage({
            id: 'Load.PreviewViewer.ErrorEmailRecipient'
          })
        )
      } else {
        setError(null)
      }
    })
  }

  const intSearchRecipient = (selectedEmail) => {
    searchRecipientsCallback({ email: selectedEmail }, null, []).then((res) => {
      if (res.Items.length === 0) {
        setError(
          intl.formatMessage({
            id: 'Load.PreviewViewer.ErrorEmailRecipient'
          })
        )
      } else {
        setError(null)
      }
    })
  }

  return (
    <div className='c-input-email'>
      <div className='c-input-email__body'>
        <InputText
          placeholder={intl.formatMessage({
            id: 'Load.MailupCommon.PlaceholderSelectEmail'
          })}
          value={email}
          onChange={handleChange}
          className='c-input-email__body__input'
        />
        <Button
          onClick={() => handleApply(email)}
          data-mu-test='select-email-apply'
          kind='primary'
          disabled={email === ''}
        >
          {intl.formatMessage({ id: 'Load.Common.Apply' })}
        </Button>
      </div>
      {!!error && <div className='c-input-email__error'>{error}</div>}
      {lastEmailsSelected && lastEmailsSelected.length > 0 && (
        <div className='c-input-email__last-selected'>
          <div className='c-input-email__last-selected__title'>
            {intl.formatMessage({ id: 'Load.PreviewViewer.LastSelected' })}
          </div>
          {lastEmailsSelected &&
            lastEmailsSelected.map((email) => (
              <Button
                className='c-input-email__last-selected__button'
                kind='neutral'
                size='sm'
                disabled={email.selected}
                key={email.value}
                onClick={() => selectEmail(email)}
              >
                {email.value}
              </Button>
            ))}
        </div>
      )}
    </div>
  )
}

InputEmail.defaultProps = {
  lastEmails: []
}

InputEmail.propTypes = {
  lastEmails: PropTypes.arrayOf(PropTypes.object),
  searchRecipientsCallback: PropTypes.func
}
